import { render, staticRenderFns } from "./company-card.vue?vue&type=template&id=abbe252c&scoped=true&"
import script from "./company-card.vue?vue&type=script&lang=js&"
export * from "./company-card.vue?vue&type=script&lang=js&"
import style0 from "./company-card.vue?vue&type=style&index=0&id=abbe252c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbe252c",
  null
  
)

export default component.exports